import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { map, path } from 'ramda';

import DataTable from 'components/ui/DataTable';

const MedicalHistoryTable = ({ data, t }) => (
  <DataTable>
    <thead>
      <tr>
        <td>{t('details')}</td>
        <td>{t('response')}</td>
      </tr>
    </thead>
    <tbody>
      {map(
        ({ answer, linkId, text }) => (
          <tr key={linkId}>
            <td>
              <strong>{text}</strong>
            </td>
            <td>
              {path(['0', 'valueBoolean'], answer) ||
              path(['0', 'valueString'], answer) ||
              path(['0', 'valueDate'], answer)
                ? path(['0', 'valueString'], answer) || path(['0', 'valueDate'], answer) || t('yes')
                : t('no')}
            </td>
          </tr>
        ),
        data,
      )}
    </tbody>
  </DataTable>
);

MedicalHistoryTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MedicalHistoryTable);
